import React from 'react';
import { PriceDetails } from './PriceDetails';
import { Offer } from '@app/api';
import { useOfferPriceTotal } from 'lib/priceComputation';

interface Props {
  offer: Offer;
  className?: string;
  applyVat?: boolean;
  organizationId?: string;
}

export const OfferPriceDetails = ({
  offer,
  className,
  applyVat,
  organizationId,
}: Props) => {
  const totals = useOfferPriceTotal(offer, organizationId, applyVat);

  return (
    <PriceDetails
      products={offer.products}
      className={className}
      totals={totals}
    />
  );
};
